/**
 * What a client is allowed to hand Casey.
 *
 * Mirrors the server's allowlist in
 * `outgoing_intake_assistant.ALLOWED_CONTENT_TYPES`. Checked here so a file
 * Casey cannot read is turned away with a sentence the client can act on,
 * rather than with the server's `Invalid content_type`.
 */
const ACCEPTED_EXTENSIONS = [
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".heic",
  ".webp",
  ".doc",
  ".docx"
];

const ACCEPTED_MEDIA_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/webp",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
]);

/** The accepted kinds named the way a client would name them. */
export const ACCEPTED_UPLOAD_SUMMARY =
  "PDFs, photos (JPG, PNG, HEIC, WebP), and Word documents";

/**
 * Either signal is enough. A phone photo can arrive with no media type at all,
 * and a Word document downloaded from a mail client can arrive as a generic
 * binary, so demanding both would turn away documents the server would take.
 */
export function isAcceptedUpload(file: File): boolean {
  const name = String(file.name || "").toLowerCase();
  if (ACCEPTED_EXTENSIONS.some((extension) => name.endsWith(extension))) {
    return true;
  }
  const mediaType = String(file.type || "")
    .split(";", 1)[0]
    .trim()
    .toLowerCase();
  return ACCEPTED_MEDIA_TYPES.has(mediaType);
}

/** The rejection, naming the file so it is clear which one to swap out. */
export function unsupportedUploadMessage(file: File): string {
  return `Casey can read ${ACCEPTED_UPLOAD_SUMMARY}. "${file.name}" is not one of those.`;
}
